// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hHecBelHs3vrj6 {\n  display: flex;\n  align-items: center;\n  line-height: 16px;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n.pnR8CV1TjzqGtN {\n  margin-left: 4px;\n  border: 1px solid var(--ds-border-inverse, #505F79);\n  border-radius: 2px;\n  background-color: var(--ds-background-neutral, #505F79);\n  padding: 1px 8px;\n  line-height: 16px;\n  font-family: ui-monospace, 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Courier, monospace;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": "hHecBelHs3vrj6",
	"tooltipShortcut": "pnR8CV1TjzqGtN"
};
export default ___CSS_LOADER_EXPORT___;
